/**
 * @(#)2020/04/2.
 * Date，原生Date的包装
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Moment from "moment";
import React, { Component } from "react";
import { DatePicker, TimePicker } from "antd";
import { toArray, get } from "../../../utils";
import { Connection, YxComponent } from "../../YxComponent";

class BaseDate extends YxComponent {
  constructor(props, content) {
    super(props, content);
    this.state = {
      value: null,
    };
  }

  onChange = (valuesMoment, values) => {
    this.setState({ value: valuesMoment });
    get(this.props, "onChange", () => {})(valuesMoment, values);
  };

  /**
   * 默认值格式化
   *
   * @memberof Date
   */
  format = () => {
    const value = get(this.props, "value", null);
    const format = this.props.format;
    let result = value;
    if (value instanceof Array) {
      result = toArray(value).map((item) => Moment(item, format));
    } else if (typeof value === "string") {
      result = Moment(value, format);
    }
    return result;
  };

  get param() {
    const value = this.format();
    return {
      ...this.props,
      value: value,
      onChange: this.onChange,
    };
  }

  render() {
    const type = get(this.props, "type", "date");
    let control = {
      date: DatePicker,
      time: TimePicker,
      week: DatePicker.WeekPicker,
      month: DatePicker.MonthPicker,
      range: DatePicker.RangePicker,
    };
    const DOM = control[type];
    return <DOM {...this.param}></DOM>;
  }
}

export default BaseDate;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Date/BaseDate.js